import queryString from 'query-string';

/**
 * URL query parameters may occur several times, in which case they are parsed to an array. To make
 * dealing with this edge case a lot easier every where else, this function ensures that _only the
 * first_ value is returned -- and never an array.
 */
export function getNormalizedQueryStringParameter(parameterName: string): string | null {
  const rawValue = queryString.parse(window.location.search)[parameterName];
  return Array.isArray(rawValue) ? rawValue[0] : rawValue;
}
